var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_502_5605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 87C70.3675 87 88.5 68.8675 88.5 46.5C88.5 24.1325 70.3675 6 48 6C25.6325 6 7.49999 24.1325 7.49999 46.5C7.49999 68.8675 25.6325 87 48 87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 82.5C67.5576 82.5 83.4122 66.6454 83.4122 47.0877C83.4122 27.5301 67.5576 11.6755 48 11.6755C28.4424 11.6755 12.5878 27.5301 12.5878 47.0877C12.5878 66.6454 28.4424 82.5 48 82.5Z",
    fill: "#C1C7D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8612 47.7489C55.8612 47.7489 56.7429 51.202 61.0776 51.202C65.1918 51.202 66.2939 47.7489 66.2939 47.7489",
    stroke: "#505F79",
    strokeWidth: 4.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7796 47.7489C29.7796 47.7489 30.6612 51.202 34.9959 51.202C39.1102 51.202 40.2122 47.7489 40.2122 47.7489",
    stroke: "#505F79",
    strokeWidth: 4.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2857 66.9979C40.2857 66.9979 46.751 61.5611 55.7143 66.9979",
    stroke: "#505F79",
    strokeWidth: 3.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8286 10.7939C23.8286 10.7939 30.5143 21.0796 32.4245 26.5163C34.2612 31.8061 33.0123 37.6102 28.0163 40.1816C23.0204 42.753 16.9225 40.7694 14.3511 35.7734C12.8082 32.7612 13.1755 29.4551 14.3511 26.5163C17.1429 19.4633 22.947 10.7939 22.947 10.7939C23.0939 10.5 23.3878 10.4265 23.6817 10.5735C23.6817 10.5735 23.8286 10.7204 23.8286 10.7939Z",
    fill: "#7A869A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_502_5605",
    x: -4.2,
    y: -3.9,
    width: 104.4,
    height: 104.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_502_5605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_502_5605",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotHappy);
export default __webpack_public_path__ + "static/media/not-happy.a0d20a70d53e6be30e8206afdcebf926.svg";
export { ForwardRef as ReactComponent };